module.exports = __webpack_public_path__ + "img/img-franquicias-restaurantes-multisucursal.c4700d36.webp";